export const fishJackpotType = {
  GET_FISH_JACKPOT_LIST_REQUEST: "GET_FISH_JACKPOT_LIST_REQUEST",
  GET_FISH_JACKPOT_LIST_SUCCESS: "GET_FISH_JACKPOT_LIST_SUCCESS",
  GET_FISH_JACKPOT_LIST_FAIL: "GET_FISH_JACKPOT_LIST_FAIL"
};
